// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AcceptTermsController from "./accept_terms_controller"
application.register("accept-terms", AcceptTermsController)

import AiRequestController from "./ai_request_controller"
application.register("ai-request", AiRequestController)

import AutoplayController from "./autoplay_controller"
application.register("autoplay", AutoplayController)

import CalloutSwipeController from "./callout_swipe_controller"
application.register("callout-swipe", CalloutSwipeController)

import CheckboxRevealController from "./checkbox_reveal_controller"
application.register("checkbox-reveal", CheckboxRevealController)

import ClearStorageController from "./clear_storage_controller"
application.register("clear-storage", ClearStorageController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommentController from "./comment_controller"
application.register("comment", CommentController)

import ContactRequestController from "./contact_request_controller"
application.register("contact-request", ContactRequestController)

import ContentMediaSelectorController from "./content_media_selector_controller"
application.register("content-media-selector", ContentMediaSelectorController)

import ContentTypeSelectorController from "./content_type_selector_controller"
application.register("content-type-selector", ContentTypeSelectorController)

import EditorJsController from "./editor_js_controller"
application.register("editor-js", EditorJsController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import InputRangeController from "./input_range_controller"
application.register("input-range", InputRangeController)

import LoaderController from "./loader_controller"
application.register("loader", LoaderController)

import MasonryGridController from "./masonry_grid_controller"
application.register("masonry-grid", MasonryGridController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NewsletterSubscriptionController from "./newsletter_subscription_controller"
application.register("newsletter-subscription", NewsletterSubscriptionController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RichTextContentController from "./rich_text_content_controller"
application.register("rich-text-content", RichTextContentController)

import RichTextEditorController from "./rich_text_editor_controller"
application.register("rich-text-editor", RichTextEditorController)

import ScraperRequestController from "./scraper_request_controller"
application.register("scraper-request", ScraperRequestController)

import SelectRevealController from "./select_reveal_controller"
application.register("select-reveal", SelectRevealController)

import SetContentTypeController from "./set_content_type_controller"
application.register("set-content-type", SetContentTypeController)

import SlideshowController from "./slideshow_controller"
application.register("slideshow", SlideshowController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TomSelectBaseController from "./tom_select_base_controller"
application.register("tom-select-base", TomSelectBaseController)

import TomSelectCreateController from "./tom_select_create_controller"
application.register("tom-select-create", TomSelectCreateController)

import TomSelectedController from "./tom_selected_controller"
application.register("tom-selected", TomSelectedController)

import TurboRefreshController from "./turbo_refresh_controller"
application.register("turbo-refresh", TurboRefreshController)
